var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlerts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.607,
    height: 25.815,
    viewBox: "0 0 29.607 25.815",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-alert-triangle",
    "data-name": "Icon feather-alert-triangle",
    transform: "translate(-0.83 -2.846)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_414",
    "data-name": "\\uD328\\uC2A4 414",
    d: "M15.634,2.846A4.077,4.077,0,0,1,19.09,4.775l0,.007L29.881,22.6l.012.021a4.01,4.01,0,0,1,.011,4.013,4.067,4.067,0,0,1-3.468,2.023H4.831a4.067,4.067,0,0,1-3.468-2.024,4.01,4.01,0,0,1,.011-4.013l.012-.021L12.173,4.782l0-.007A4.077,4.077,0,0,1,15.634,2.846Zm.9,3.494a1.061,1.061,0,0,0-1.794,0L3.96,24.144a1,1,0,0,0,0,1,1.054,1.054,0,0,0,.895.521H26.41a1.054,1.054,0,0,0,.895-.521,1,1,0,0,0,0-1Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_415",
    "data-name": "\\uD328\\uC2A4 415",
    d: "M18,20.355a1,1,0,0,1-1-1V13.5a1,1,0,0,1,2,0v5.855A1,1,0,0,1,18,20.355Z",
    transform: "translate(-2.366 -1.321)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_201",
    "data-name": "\\uD0C0\\uC6D0 201",
    cx: 1.1,
    cy: 1.1,
    r: 1.1,
    transform: "translate(14.534 19.998)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD0C0\\uC6D0_201_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uD0C0\\uC6D0 201 - \\uC724\\uACFD\\uC120",
    d: "M1.1,0A1.1,1.1,0,1,1,0,1.1,1.1,1.1,0,0,1,1.1,0Z",
    transform: "translate(14.534 19.998)",
    fill: "currentColor"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlerts);
export default __webpack_public_path__ + "static/media/alerts.15fa33c4fbd91e1c11201010f384962d.svg";
export { ForwardRef as ReactComponent };